module.exports = __webpack_public_path__ + "static/img/1_1_3_1.f25ff7ef.jpg";